/**
 * The box `Input`, `Textarea` and `Select` share, so the three read as one family on every screen.
 *
 * The border is `borderControl`, which meets 3:1 against every surface (WCAG 1.4.11), and darkens
 * on hover. Text follows the density theme's body size, which stays 16px on a touch screen in
 * either density, because iOS zooms the page into any smaller input.
 */
import * as stylex from "@stylexjs/stylex";
import "@lattice/tokens/color.stylex";
import { color } from "@lattice/tokens/color.stylex";
import "@lattice/tokens/motion.stylex";
import { motion } from "@lattice/tokens/motion.stylex";
import "@lattice/tokens/size.stylex";
import { size } from "@lattice/tokens/size.stylex";
import "@lattice/tokens/space.stylex";
import { border, radius, space } from "@lattice/tokens/space.stylex";
import "@lattice/tokens/text.stylex";
import { text } from "@lattice/tokens/text.stylex";
export const controlStyle = {
  box: {
    kB7OPa: "x9f619",
    kzqmXN: "xh8yej3",
    k7Eaqz: "xeuugli",
    kogj98: "x1ghz6dp",
    kg3NbH: "xerji9v",
    kMv6JI: "x1cikjda",
    kGuDYH: "xjmaktb",
    kLWn49: "xejwzen",
    kMwMTN: "xm8xz4y",
    kWkggS: "x40k5rp",
    kMzoRj: "xdq7b4a",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xdmng3o xbqcxop",
    kaIpWk: "x1fbwzx",
    k1ekBW: "xq90yva",
    kIyJzY: "x149xavy",
    kAMwcw: "xa02eh3",
    k8Qsv1: "x18eff7n",
    kH8XJS: "x7xwk5j",
    $$css: true
  },
  md: {
    kAzted: "x1envrbd",
    $$css: true
  },
  lg: {
    kAzted: "x1nchb1j",
    kg3NbH: "x3i8z2n",
    $$css: true
  },
  invalid: {
    kVAM5u: "xjygxg x1rf94cd",
    $$css: true
  },
  disabled: {
    kWkggS: "x14ba300",
    kVAM5u: "x17k0sde",
    kMwMTN: "x16nvyyk",
    kkrTdU: "x1h6gzvc",
    $$css: true
  },
  readOnly: {
    kWkggS: "x14ba300",
    kVAM5u: "x17k0sde",
    $$css: true
  }
};

/** What `Field` hands its control, so the label, hint and error reach it. */
export interface FieldControl {
  readonly id: string;
  readonly "aria-describedby": string | undefined;
  readonly "aria-invalid": true | undefined;
  readonly "aria-required": true | undefined;
}